import { IApplicationState } from '../../types/store';

export const selectMarkedListSchema = (state: IApplicationState): string | undefined => {
  return state.seo.markedList?.schema || undefined;
};
